'use strict';

export class NationalPrefixControl {
  constructor (element, triggeredInput){
    this.$control = document.createElement('div')
    this.$control.classList.add('si_controls__control')
    this.$control.classList.add('si_control')
    this.$control.classList.add('si_control--toggle')

    const $label = document.createElement('label')
    $label.classList.add(`si_control__label`)
    if(document.documentElement.lang == 'en'){
      $label.innerHTML = 'Display National Prefix'
    }else{
      $label.innerHTML = 'Afficher le préfixe'
    }

    this.$input = document.createElement('input')
    this.$input.classList.add(`si_control__input`)
    this.$input.classList.add(`si_input`)
    this.$input.classList.add(`si_input--toggle`)
    this.$input.setAttribute('type', 'checkbox')

    this.origValue = element.attr('has-national-prefix') == 'true'
    this.setValue(this.origValue)

    this.$input.addEventListener('change', (e) => {
      e.target.checked ? element.node.setAttribute('has-national-prefix', 'true') : element.node.removeAttribute('has-national-prefix')
      triggeredInput.dispatchEvent(new Event('input'))
    })

    this.$control.appendChild($label)
    $label.appendChild(this.$input)

    this.reset = this.reset.bind(this, element)

    return this
  }

  getElement() {
    return this.$control
  }

  setValue(value) {
    this.$input.checked = value
    return this
  }

  getValue() {
    return this.$input.value
  }

  reset(element) {
    this.origValue ? element.node.setAttribute('has-national-prefix', 'true') : element.node.removeAttribute('has-national-prefix')
    this.setValue(this.origValue)

    return this
  }
}
